import { BridgeResponse, NativeEventMessage } from './bridge'

// 안드로이드 인터페이스
interface SharedWebInterface {
  showAlert: (message: string, callback?: string) => void
  close: () => void
}

// iOS 인터페이스
interface WebkitMessageHandler {
  postMessage: (message: any) => void
}

interface WebkitInterface {
  messageHandlers?: {
    adison?: WebkitMessageHandler
  }
}

interface AndroidInterface {
  receiveMessage: (message: string) => void
}

// Window 인터페이스 확장
declare global {
  interface Window {
    SharedWeb?: SharedWebInterface
    webkit?: WebkitInterface
    sharedWeb?: typeof sharedWeb
    Android?: AndroidInterface
    appMessageHandler?: (response: BridgeResponse) => void
    handleNativeMessage?: (messageStringOrObject: string | NativeEventMessage) => void
  }
}

//
export const sharedWeb = {
  showAlert(message: string, callback?: string): void {
    if (window.SharedWeb) {
      if (callback === undefined) {
        window.SharedWeb.showAlert(message)
      } else {
        window.SharedWeb.showAlert(message, callback)
      }
    } else if (window.webkit?.messageHandlers?.adison) {
      const messageData = {
        command: 'showAlert',
        message,
        callback
      }
      window.webkit.messageHandlers.adison.postMessage(messageData)
    } else {
      console.log('No native APIs found.')
      window.alert(message)
      if (callback !== undefined) {
        // Note: Using eval is generally discouraged. Consider using a safer alternative
        // based on your specific needs
        eval(callback)
      }
    }
  },
  dismiss(): void {
    if (window.SharedWeb) {
      window.SharedWeb.close()
    } else if (window.webkit?.messageHandlers?.adison) {
      const messageData = {
        command: 'close'
      }
      window.webkit.messageHandlers.adison.postMessage(messageData)
    } else {
      console.log('No native APIs found.')
      window.close()
    }
  }
}

// Export the utility
// export default sharedWeb;

// Assign to window for global access (if needed)
if (typeof window !== 'undefined') {
  window.sharedWeb = sharedWeb
}
